import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CloseCircleFilled, HolderOutlined } from '@ant-design/icons'

import { ThumbnailImage } from '../../components/ThumbnailImage'

interface SortableImageItemProps {
  id: string
  url: string
  onRemove: (url: string) => void
}

export function SortableImageItem({ id, url, onRemove }: SortableImageItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    display: 'inline-block',
    width: 104,
    height: 104,
    marginRight: 8,
    marginBottom: 8,
    border: '1px solid #d9d9d9',
    borderRadius: 8,
    overflow: 'hidden',
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} data-testid="product-form-image-item">
      <div
        {...listeners}
        style={{
          position: 'absolute',
          top: 4,
          left: 4,
          zIndex: 2,
          cursor: 'grab',
          background: 'rgba(255,255,255,0.8)',
          borderRadius: 4,
          padding: '2px 4px',
        }}
      >
        <HolderOutlined />
      </div>
      <CloseCircleFilled
        data-testid="product-form-image-remove-btn"
        onClick={() => onRemove(url)}
        style={{
          position: 'absolute',
          top: 4,
          right: 4,
          zIndex: 2,
          fontSize: 18,
          color: '#ff4d4f',
          cursor: 'pointer',
          background: 'white',
          borderRadius: '50%',
        }}
      />
      <ThumbnailImage
        src={url}
        alt="product"
        width={102}
        height={102}
        mask={false}
        style={{ borderRadius: 0 }}
      />
    </div>
  )
}
